import { render } from "./Header.vue?vue&type=template&id=ebfcb6a2&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "@/assets/css/components/header.css?vue&type=style&index=0&id=ebfcb6a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\info\\Documents\\ownersite.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebfcb6a2"]])

export default __exports__